import { Component, ElementRef, ViewChild } from '@angular/core';
import { MagliveApiClient } from "src/lib/api-client/maglive-api-client";
import { environment } from "src/env/environment";
import { PlayerHLS } from "src/lib/player/player-hls";
import { WatchData, LiveCommentIndex, LiveComment, Live } from 'src/lib/entity/live';
import { AngularFirestore } from '@angular/fire/firestore';
import { FirestoreAccess } from "src/lib/firestore-access";
import { saveAs } from 'file-saver';
import { Menu } from '../index/live-index.component';
import * as encoding from 'encoding-japanese';
import { map, catchError, switchMap } from 'rxjs/operators';
import * as Rx from 'rxjs';
import { Room } from 'src/lib/entity/room';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'admin-live-index-detail',
  templateUrl: './live-index-detail.component.html',
  styleUrls: ['../../../../pages/admin/startbootstrap-sb-admin-gh-pages/src/scss/styles.scss', './live-index-detail.component.scss']
})
export class AdminLiveIndexDetailComponent {

  public displayControllsOpacity = 1;
  public isPlaying = false;
  public isMuted = true;
  public  videoElement: HTMLVideoElement;
  public isScreenRotated;
  public isFullScreen = false;
  public watchedProgress = 0;
  public isLoadingContent = false;
  public durationRemaining = '00:00';
  public totalDuration = '00:00';
  public currentProgress = '00:00';
  public volumeLevel = 1;
  public controlsTimeout: number;
  @ViewChild('videoContainer') videoContainer: ElementRef;
  @ViewChild('progressBar') progressBar: ElementRef;
  @ViewChild('volumeBar') volumeBar: ElementRef;

  private hlsPlayer: PlayerHLS;
  private room: Room
  private magazineId: number

  live: Live;
  watchData$: WatchData | "NOT_FOUND";
  liveComments: LiveCommentIndex[];
  isInvalidCsvDl: boolean;
  downloadUrl: string;
  isInvalidLiveConvert: boolean;
  monitoringURL: string;
  isInvalidLiveUpload: boolean;

  liveId: string;
  detailType: Menu;

  @ViewChild("video", {static: false})
  video: ElementRef<HTMLVideoElement>;

  constructor(
    private afs: AngularFirestore,
    private fsa: FirestoreAccess,
    private toastr: ToastrService,
    private route: ActivatedRoute,
  ) {
    this.route.params.subscribe(params =>
      this.liveId = params['id'],
    );
    this.route.params.subscribe(params =>
      this.magazineId = params['magazineId'] ?? null
    );
    if(this.magazineId != null) {
      this.detailType = "creator_videos"
    } else {
      this.detailType = "video_list"
    }
  }

  ngAfterViewInit() {
    this.videoElement = this.video.nativeElement;
    this.videoContainer.nativeElement.addEventListener('mousemove', () => {
      this.displayControls();
    });
    this.videoCreate();
    this.fsa.getLive(this.liveId).pipe(
      map(live => {
        if(live != null) {
          this.live = live
          if(live.monitoringToken != null) {
            this.monitoringURL = this.getMonitoringURL(this.liveId, live.monitoringToken)
          }   
        }
        return live
      }),
      switchMap(live => {
        if(live.roomId != null) {
          this.setDownloadUrl(live.roomId)
          return this.fsa.getRoom(live.roomId)
        } else {
          return Rx.EMPTY
        }
      })
    ).subscribe(room => {
      if(room != null) {
        this.room = room
        this.isInvalidLiveUpload = this.live.archiveUploadStatus != null && room.convert_hls_status != "success"
        this.isScreenRotated = this.live.options.isScreenRotated;
      }
    })

    this.getLiveComment(this.liveId);
    this.videoElement.addEventListener('timeupdate', () => {
      this.watchedProgress =
        (this.videoElement.currentTime / this.videoElement.duration) * 100;
      const totalSecondsRemaining =
        this.videoElement.duration - this.videoElement.currentTime;
        const duration = this.videoElement.duration;
        const running = this.videoElement.currentTime

      this.durationRemaining = this.videoTimeConversion(totalSecondsRemaining);
      this.totalDuration = this.videoTimeConversion(duration);
      this.currentProgress = this.videoTimeConversion(running);
    });
  
    this.videoElement.addEventListener('ended', (data) => {
      this.isPlaying = false;
      this.displayControllsOpacity = 1;
    });
  }
  
  ngOnDestroy() {
    if (this.hlsPlayer) {
      this.hlsPlayer.destroy();
      this.hlsPlayer = null;
    }
  }

  videoTimeConversion(totalSeconds){
    if(isNaN(totalSeconds))
      return '00:00';
    var sec_num = parseInt(totalSeconds, 10); 
    var h   = Math.floor(sec_num / 3600);
    var m = Math.floor((sec_num - (h * 3600)) / 60);
    var s = sec_num - (h * 3600) - (m * 60);
    var hours: string;
    var minutes:string;
    var seconds: string;
    h<10 ? hours="0"+h : hours = h.toString();
    m<10 ? minutes="0"+m : minutes = m.toString();
    s<10 ? seconds="0"+s : seconds = s.toString();

    return `${
      h > 0 ? hours + ':' : ''
    }${minutes}:${seconds}`;
  }
  setVolume(){
    this.videoElement.volume = this.volumeBar.nativeElement.value;
    if(this.videoElement.volume > 0){
      this.isMuted = false;
    } else {
      this.isMuted = true;
    }

  }
  displayControls() { // 5 秒後にビデオ コントロール バーを非表示にする
    this.displayControllsOpacity = 1;
    if (this.controlsTimeout) {
      clearTimeout(this.controlsTimeout);
    }
    this.controlsTimeout = window.setTimeout(() => {
      if (this.isPlaying) {
        this.displayControllsOpacity = 0;
      } else {
        this.displayControllsOpacity = 1;
      }
    }, 5000);
  }
  playPause() {
    if (this.videoElement.paused) {
      this.videoElement.play();
      this.isPlaying = true;
    } else {
      this.videoElement.pause();
      this.isPlaying = false;
    }
  }

  toggleMute() {
    this.videoElement.muted = !this.videoElement.muted;
    if (this.videoElement.muted) {
      this.isMuted = true;
    } else {
      this.isMuted = false;
    }
  }

  // Update the progress bar
  updateProgressBar() {
    // Work out how much of the media has played via the duration and currentTime parameters
    var percentage = Math.floor((100 / this.videoElement.duration) * this.videoElement.currentTime);
    // Update the progress bar's value
    this.progressBar.nativeElement.value = percentage;
    // Update the progress bar's text (for browsers that don't support the progress element)
    this.progressBar.nativeElement.innerHTML = percentage + '% played';
  }
  seek(e) {
      var percent = e.offsetX / this.progressBar.nativeElement.offsetWidth;
      this.videoElement.currentTime = percent * this.videoElement.duration;
      e.target.value = Math.floor(percent / 100);
      e.target.innerHTML = this.progressBar.nativeElement.value + '% played';
  }
  toggleFullScreen() {
    if (
      !document.fullscreenElement &&
      !(document as Document).fullscreenElement
    ) {
      this.openFullscreen();
    } else {
      this.closeFullscreen();
    }
  }
  openFullscreen() {
    this.isFullScreen = true;
    if (this.videoContainer.nativeElement.requestFullscreen) {
      this.videoContainer.nativeElement.requestFullscreen();
    } else if (this.videoContainer.nativeElement.webkitRequestFullscreen) {
      /* Safari */
      this.videoContainer.nativeElement.webkitRequestFullscreen();
    }
  }

  /* Close fullscreen */
  closeFullscreen() {
    this.isFullScreen = false;
    if ((document as Document).exitFullscreen) {
      (document as Document).exitFullscreen();
    } 
  }
  
  private setDownloadUrl(roomId: string) {
    this.afs.doc<Room>(`rooms/${roomId}`).valueChanges().subscribe( value => {
      if (value.convert_mp4_status === "success") {
        this.createDownloadUrl(roomId)
      }
    })
  }

  videoCreate(): void {
    this.isLoadingContent = true
    MagliveApiClient.getMngWatchData(this.liveId).subscribe(val => {
      this.hlsPlayer = new PlayerHLS(this.video)
      this.watchData$ = val;
      if (this.watchData$ !== "NOT_FOUND") {
        this.hlsPlayer.play(this.watchData$.hlsEndpoint, null, true);
        this.isLoadingContent = false
        this.isPlaying = true;
      }
    })
  }

  exportCsvLiveComment(liveId: string): void {
    if(liveId === undefined) return
    this.isInvalidCsvDl = true;

    MagliveApiClient.exportCsvLiveComment(liveId).subscribe(
      value => {
        if (value === "NOT_FOUND"){
          this.isInvalidCsvDl = false;
          this.toastr.error('コメントが存在しません')
          return;
        }

        const fileName = value.fileName;
        const fileData = value.fileData;

        const unicodeList = [];
        for(let i = 0; i < fileData.length; i++) {
          unicodeList.push(fileData.charCodeAt(i))
        }

        const shiftJisCodeList = encoding.convert(unicodeList, 'SJIS', 'UNICODE')
        const unit8Array = new Uint8Array(shiftJisCodeList)

        const blob = new Blob([unit8Array], {type: 'text/csv'});
 
        saveAs(blob, fileName);
        this.isInvalidCsvDl = false;
    },
      error => {
      this.isInvalidCsvDl = false;
      console.log(error);
    });
  }

  getLiveComment(liveId: string) {
    this.afs.collection(`lives/${liveId}/comments`, ref => {
      return ref.orderBy("createdAt", 'asc')
    }).valueChanges({idField: 'id'})
    .subscribe(x => {
      this.liveComments = []
      x.map(item => {

        let liveComment = item as LiveComment;

        let liveCommentIndex: LiveCommentIndex = {
          id: liveComment.id,
          userId: liveComment.userId,
          userNickname: liveComment.userNickname,
          message: liveComment.message,
          createdAt: new Date(liveComment.createdAt.seconds*1000).toLocaleString()
        }

        this.liveComments.push(liveCommentIndex);
      })
    })

  }

  private getMonitoringURL(liveId: string, monitoringToken: string): string {
    return environment.baseURL.magliveWeb + 'lives/' + liveId + '?token=' + monitoringToken;
  }

  createMonitoringUrl(liveId: string) {
    MagliveApiClient.getMonitoringUrl(liveId).subscribe(x => {
      if (x !== 'NOT_AUTHORIZED'){
          this.monitoringURL = x.monitoringURL;
      }
    })
  }
  

  private createDownloadUrl(roomId: string) {
    MagliveApiClient.createDownloadUrl(roomId).pipe(
      catchError(() => {
        this.toastr.error("署名付きURLの発行に失敗しました")
        this.isInvalidLiveConvert = false;
        return Rx.EMPTY
      })
      ).subscribe( value => {
        this.downloadUrl = value.url
      })
  }

  convertLive(roomId: string) {

    if (this.downloadUrl != undefined || this.isInvalidLiveUpload) return
    
    this.isInvalidLiveConvert = true;

    MagliveApiClient.convertLive(roomId).pipe(
      catchError(() => {
        this.toastr.error("動画の変換に失敗しました")
        this.isInvalidLiveConvert = false;
        return Rx.EMPTY
      })
    ).subscribe(() => {

      // rooms.convert_mp4_statusを監視する
      const timer = Rx.interval(1000).subscribe(() => {          
        this.afs.doc<Room>(`rooms/${roomId}`).valueChanges().subscribe( value => {
          let convertMp4Status = value.convert_mp4_status;
          if (convertMp4Status === "success") {
            this.toastr.success("動画の変換に成功しました")
            this.isInvalidLiveConvert = false;
            this.createDownloadUrl(roomId);
          }
          timer.unsubscribe();
        });
      })
    });
  
  }

  downloadLive(){
    document.location.href = this.downloadUrl;
  }
}
